import { render, staticRenderFns } from "./TechStatusesActions.vue?vue&type=template&id=2a3cb0ce&"
import script from "./TechStatusesActions.vue?vue&type=script&lang=js&"
export * from "./TechStatusesActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports